import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'textpretty',
  standalone: true,
})
export class TextPrettyPipe implements PipeTransform {
  transform(text: string | any): string {
    let sanitizedText: string;
    if (!text) {
      sanitizedText = '';
    } else if (typeof text === 'string') {
      sanitizedText = text;
    } else {
      sanitizedText = (text as any).toString();
    }

    const prettyText = sanitizedText.replace(/_/g, ' ');
    return prettyText;
  }
}
